<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานหลัก</label>
                                <Button
                                    @click="showOrganize = true"
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_6_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteAt = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="event_name">{{ $t('event_name') }}</label>
                            <InputText
                                id="event_name"
                                type="text"
                                v-model="event_name"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_3_search', 'Input')"
                            />
                        </div>

                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="startDate">{{ $t('startDate') }}</label>
                                <Calendar
                                    dateFormat="dd/mm/yy"
                                    :showButtonBar="true"
                                    :maxDate="setTimeMaxMin(toDate)"
                                    :monthNavigator="true"
                                    :yearNavigator="true"
                                    yearRange="2000:2050"
                                    :locale="th"
                                    id="disaster_startDate"
                                    v-model="startDate"
                                ></Calendar>
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="toDate">{{ $t('toDate') }}</label>
                                <Calendar
                                    dateFormat="dd/mm/yy"
                                    :showButtonBar="true"
                                    :minDate="setTimeMaxMin(startDate)"
                                    :monthNavigator="true"
                                    :yearNavigator="true"
                                    yearRange="2000:2050"
                                    :locale="th"
                                    id="disaster_toDate"
                                    v-model="toDate"
                                ></Calendar>
                            </div>
                        </div>

                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disasterType">{{ $t('disaster_type') }}</label>
                                <Dropdown
                                    v-model="disasterTypeSelect"
                                    :options="disasterTypeOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="disasterTypeOptions">
                                        <div v-if="disasterTypeOptions.value">
                                            <div>{{ disasterTypeOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ disasterTypeOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="disasterTypeOptions">
                                        <div>{{ disasterTypeOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disasterStatusOptions">{{ $t('disaster_status') }}</label>
                                <Dropdown
                                    v-model="disasterStatusSelect"
                                    :options="disasterStatusOptions"
                                    optionLabel="name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="disasterStatusOptions">
                                        <div v-if="disasterStatusOptions.value">
                                            <div>{{ disasterStatusOptions.value.name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ disasterStatusOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="disasterStatusOptions">
                                        <div>{{ disasterStatusOptions.option.name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="provinceOptions">{{ $t('province') }}</label>
                                <Dropdown
                                    v-model="selectedProvince"
                                    :options="provinceOptions"
                                    optionLabel="province_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="provinceOptions">
                                        <div v-if="provinceOptions.value">
                                            <div>{{ provinceOptions.value.province_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="provinceOptions">
                                        <div>{{ provinceOptions.option.province_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="amphurOptions">{{ $t('amphur') }}</label>
                                <Dropdown
                                    :disabled="isDisabledAmphur == 1"
                                    v-model="selectedAmphur"
                                    :options="amphurOptions"
                                    optionLabel="amphur_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="amphurOptions">
                                        <div v-if="amphurOptions.value">
                                            <div>{{ amphurOptions.value.amphur_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="amphurOptions">
                                        <div>{{ amphurOptions.option.amphur_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="tambonOptions">{{ $t('tambon') }}</label>
                                <Dropdown
                                    :disabled="isDisabledTambon == 1"
                                    v-model="selectedTambon"
                                    :options="tambonOptions"
                                    optionLabel="tambon_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="tambonOptions">
                                        <div v-if="tambonOptions.value">
                                            <div>{{ tambonOptions.value.tambon_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="tambonOptions">
                                        <div>{{ tambonOptions.option.tambon_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disaster_location">{{ $t('disaster_location') }}</label>
                                <InputText
                                    id="disaster_location"
                                    type="text"
                                    v-model="disaster_location"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Input')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Button')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disasterDetailOptions">{{ $t('disaster_detail') }}</label>
                                <InputText
                                    id="disaster_detail"
                                    type="text"
                                    v-model="disaster_detail"
                                    ref="TextBox_4_search"
                                    @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_5_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_6_search', 'Button')"
                                />
                                <!-- <Dropdown
                  v-model="disasterDetailSelect"
                  :options="disasterDetailOptions"
                  optionLabel="system_name"
                  :filter="true"
                  :placeholder="$t('placeholderSelectBox')"
                  :showClear="true"
                >
                  <template #value="disasterDetailOptions">
                    <div v-if="disasterDetailOptions.value">
                      <div>{{ disasterDetailOptions.value.system_name }}</div>
                    </div>
                    <span v-else>
                      {{ disasterDetailOptions.placeholder }}
                    </span>
                  </template>
                  <template #option="disasterDetailOptions">
                    <div>{{ disasterDetailOptions.option.system_name }}</div>
                  </template>
                </Dropdown> -->
                            </div>
                        </div>

                        <div class="p-field p-col">
                            <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                <Button
                                    @click="clearSearchField()"
                                    :label="$t('clearBtn')"
                                    class="p-button-clear p-ml-3 p-mr-3 p-mt-2"
                                    ref="TextBox_5_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_6_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_3_search', 'Input')"
                                />
                                <Button
                                    @click="searchDisasterInfo()"
                                    :label="$t('searchBtn')"
                                    class="p-button-info p-mt-2"
                                    ref="TextBox_6_search"
                                    @keyup.left="moveFocus($event, 'TextBox_5_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_4_search', 'Input')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="disasterInfo_table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <!-- <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
      ></organize-table>
    </Dialog> -->
        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table @selectOrganization="selectedOrganize_passValue" :parentmessage="parentmessage_organize"></organize-table>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <DataTable
                :value="disasterInfo_table"
                :paginator="true"
                :rows="10"
                scrollHeight="500px"
                :loading="loading"
                dataKey="id"
                sortField="index"
                :rowHover="true"
                :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="disasterInfoModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>
                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" /><InputText v-model="filters['global']" :placeholder="$t('searchHeader')" />
                            </span>
                        </div>
                    </div>
                </template>
                <template #empty>{{ $t('TableEmpty') }}</template>
                <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('100px', 'center', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div class="table_row">
                            <!-- {{ dataTable.index+1 }} -->
                            {{ dataTable.data.index }}
                        </div>
                    </template>
                </Column>

                <Column field="event_name" :header="$t('event_name')" :sortable="true" :headerStyle="tableColSticky('250px', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div hidden>{{ dataTable.data.hazard_id }}</div>
                        {{ dataTable.data.event_name }}
                        <div class="p-text-italic p-text-light approve-label" v-if="dataTable.data.from_flag == 1 || dataTable.data.from_flag == 0">
                            ประชาชนแจ้งเหตุ
                        </div>
                    </template>
                </Column>

                <Column
                    field="event_date_alias"
                    :header="$t('disaster_callDatetime')"
                    :sortable="true"
                    :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{
                            !dataTable.data.event_date_alias || dataTable.data.event_date_alias == null || dataTable.data.event_date_alias == ''
                                ? '-'
                                : dataTable.data.event_date_alias
                        }}
                    </template>
                </Column>
                <Column
                    field="disaster_name"
                    :header="$t('disaster_type')"
                    :sortable="true"
                    :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.disaster_name }}
                    </template>
                </Column>
                <Column
                    field="disaster_detail"
                    :header="$t('disaster_detail')"
                    :sortable="true"
                    :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div
                            v-if="
                                dataTable.data.disaster_detail != 'null' &&
                                dataTable.data.disaster_detail !== '' &&
                                dataTable.data.disaster_detail !== null
                            "
                        >
                            {{ dataTable.data.disaster_detail }}
                        </div>
                        <div v-else>-</div>
                    </template>
                </Column>

                <Column
                    field="report_phone"
                    :header="'เบอร์โทรศัพท์ผู้แจ้งเหตุ'"
                    :sortable="true"
                    :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div
                            v-if="dataTable.data.report_phone != 'null' && dataTable.data.report_phone !== '' && dataTable.data.report_phone !== null"
                        >
                            {{ dataTable.data.report_phone }}
                        </div>
                        <div v-else>-</div>
                    </template>
                </Column>

                <!-- <Column
          field="location"
          :header="$t('disaster_location')"
          :sortable="true"
          headerStyle="width: 250px"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.location != ''">
              {{ dataTable.data.location }}
            </div>
            {{ dataTable.data.tambon_name }} {{ dataTable.data.amphur_name }}
            {{ dataTable.data.province_name }}
          </template>
        </Column> -->

                <Column
                    field="event_operator_table"
                    :header="$t('main_organize')"
                    :sortable="true"
                    :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div v-if="dataTable.data.event_operator_table == '[]'">-</div>
                        <div v-else>
                            <div v-for="operator in JSON.parse(dataTable.data.event_operator_table)" :key="operator.operating_id">
                                <div v-if="operator.organize[0] == '1'">
                                    {{ operator.operating_name }}
                                </div>
                                <div v-else>-</div>
                            </div>
                        </div>
                    </template>
                </Column>

                <Column
                    field="event_level"
                    :header="$t('disaster_level')"
                    :sortable="true"
                    :headerStyle="tableColSticky('100px', 'center', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <!-- {{ dataTable.data.event_level }} -->
                        <div v-if="dataTable.data.event_level == '1'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#00902A',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.event_level == '2'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#92D14F',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.event_level == '3'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#FCFC25',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.event_level == '4'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#FE7B00',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.event_level == '5'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#FE0000',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#A09B9B',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                    </template>
                </Column>
                <Column
                    field="event_status"
                    :header="$t('disaster_status')"
                    :sortable="true"
                    :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <!-- <div v-if="dataTable.data.event_status == 'onworking'">
              {{ $t("onworking") }}
            </div>
            <div v-else>{{ $t("finish") }}</div> -->
                        <div v-if="dataTable.data.event_status == 'onworking'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#F1C40F',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ $t('onworking') }}
                            </div>
                        </div>

                        <div v-else-if="dataTable.data.event_status == 'finish'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#2ECC71',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ $t('finish') }}
                            </div>
                        </div>

                        <div v-else class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#E74C3C',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ $t('notify') }}
                            </div>
                        </div>
                    </template>
                </Column>

                <Column
                    field="date_create_ddmmyy"
                    :header="'วันที่สร้างข้อมูล'"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.date_create_ddmmyy }}
                    </template>
                </Column>

                <Column
                    field="date_update_ddmmyy"
                    :header="'วันที่ปรับปรุงข้อมูล'"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.date_update_ddmmyy }}
                    </template>
                </Column>

                <Column
                    :header="$t('controlTable')"
                    :headerStyle="table_headerStyle"
                    :bodyStyle="table_bodyStyle"
                    v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                >
                    <template #body="dataTable">
                        <div class="p-formgrid col_manege" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
                            <!-- <div class="p-formgrid p-grid"> -->
                            <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                <Button
                                    @click="
                                        editData(dataTable.data.hazard_id);
                                        temp = dataTable.data.hazard_id;
                                    "
                                    icon="pi pi-pencil"
                                    :label="table_editBTN"
                                    class="p-button-rounded p-button-warning"
                                />
                            </div>
                            <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                <Button
                                    @click="
                                        // displayConfirmation = true;
                                        temp = dataTable.data.hazard_id;
                                        deleteAt = '';
                                        alertDisplay(temp);
                                    "
                                    icon="pi pi-trash"
                                    :label="table_deleteBTN"
                                    class="p-button-rounded p-button-danger"
                                />
                            </div>
                        </div>
                        <div v-else>
                            {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                        </div>
                    </template>
                </Column>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="disasterInfoModal"
            :style="{ width: '90%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :header="header"
            id="disasterInfo_manage"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <label>{{ $t('id_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="id_disaster_name">{{ $t('event_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="id_disaster_name"
                                type="text"
                                v-model="id_disaster_name"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_id_disaster_name && !id_disaster_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_19', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_2', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_id_disaster_name && !id_disaster_name">{{ $t('id_disaster_name_validate') }}</small>
                        </div>
                        <!-- <div class="p-field p-col-12 p-lg-4 p-mt-2">
              <label for="id_disasterDate">{{ $t("startDate") }}</label>
              <Calendar
                dateFormat="dd/mm/yy"
                :showButtonBar="true"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2050"
                :locale="th"
                id="id_disasterDate"
                v-model="id_disasterDate"
                :showTime="true"
                :showSeconds="true"
                
              ></Calendar>
            </div> -->
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="id_disasterType">{{ $t('disaster_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="id_disasterTypeSelect"
                                :options="disasterTypeOptions"
                                @change="someHandler('disaster-type')"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_id_disasterTypeSelect && !id_disasterTypeSelect
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="disasterTypeOptions">
                                    <div v-if="disasterTypeOptions.value">
                                        <div>{{ disasterTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ disasterTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="disasterTypeOptions">
                                    <div class="EV_disasterOptions">{{ disasterTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_id_disasterTypeSelect && !id_disasterTypeSelect">{{
                                $t('id_disasterTypeSelect_validate')
                            }}</small>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="id_disasterDetailOptions">{{ $t('disaster_detail') }}</label>

                            <InputText
                                id="id_disaster_detail"
                                type="text"
                                v-model="id_disaster_detail"
                                required="true"
                                ref="TextBox_2"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <!-- <Dropdown
                v-model="id_disasterDetailSelect"
                :options="disasterDetailOptions"
                optionLabel="system_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
              >
                <template #value="disasterDetailOptions">
                  <div v-if="disasterDetailOptions.value">
                    <div>{{ disasterDetailOptions.value.system_name }}</div>
                  </div>
                  <span v-else>
                    {{ disasterDetailOptions.placeholder }}
                  </span>
                </template>
                <template #option="disasterDetailOptions">
                  <div>{{ disasterDetailOptions.option.system_name }}</div>
                </template>
              </Dropdown> -->
                        </div>
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="id_disasterLocation">{{ $t('disaster_location') }}</label>
                            <InputText
                                id="id_disasterLocation"
                                type="text"
                                v-model="id_disasterLocation"
                                ref="TextBox_3"
                                @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="id_disasterDate">วัน-เวลาที่รับแจ้งเหตุ</label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="id_disasterDate"
                                v-model="id_disasterDate"
                                :showTime="true"
                                :showSeconds="true"
                            ></Calendar>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="id_disasterStatusOptions">{{ $t('disaster_status') }}</label>
                            <Dropdown
                                v-model="id_disasterStatusSelect"
                                :options="disasterStatusOptions"
                                optionLabel="name"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="disasterStatusOptions">
                                    <div v-if="disasterStatusOptions.value">
                                        <div>{{ disasterStatusOptions.value.name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ disasterStatusOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="disasterStatusOptions">
                                    <div>{{ disasterStatusOptions.option.name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" -->
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="provinceOptions">{{ $t('province') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="id_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                @change="someHandler('select-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_id_selectedProvince && !id_selectedProvince
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                    <!-- <div v-else-if="provinceEKanit" >
                    <div>{{ provinceEKanit }}</div>
                  </div> -->
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_id_selectedProvince && !id_selectedProvince">{{
                                $t('id_selectedProvince_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="amphurOptions">{{ $t('amphur') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="id_isDisabledAmphur == 1"
                                v-model="id_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('select-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_id_selectedAmphur && !id_selectedAmphur
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                    <!-- <div v-else-if="amphurEKanit">
                    <div>{{ amphurEKanit }}</div>
                  </div> -->
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_id_selectedAmphur && !id_selectedAmphur">{{
                                $t('id_selectedAmphur_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="tambonOptions">{{ $t('tambon') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="id_isDisabledTambon == 1"
                                v-model="id_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_id_selectedTambon && !id_selectedTambon
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                    <!-- <div v-else-if="tambonEKanit">
                    <div>{{ tambonEKanit }}</div>
                  </div> -->
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_id_selectedTambon && !id_selectedTambon">{{
                                $t('id_selectedTambon_validate')
                            }}</small>
                        </div>
                    </div>
                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" จบ-->

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="id_call_name">{{ $t('id_call_name') }}</label>
                            <InputText
                                id="id_call_name"
                                type="text"
                                v-model="id_call_name"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_6', 'Input')"
                            />
                        </div>

                        <!-- <div class="p-field p-col-12 p-lg-6 p-mt-2">
              <label for="id_call_phone">{{ $t("id_call_phone") }}</label>
              <InputText
                id="id_call_phone"
                type="text"
                v-model="id_call_phone"
                @input="acceptNumberPhone"
              />
            </div> -->

                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="id_call_phone">{{ $t('id_call_phone') }}</label>
                            <InputText
                                id="id_call_phone"
                                type="text"
                                v-model="id_call_phone"
                                ref="TextBox_5"
                                @keyup.left="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_3', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_6', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col">
                        <!-- <div class="p-field p-col-4">
              <label for="disasterReasonOptions">{{
                $t("id_disaster_reason") +'!!!1'
              }}</label>
              <Dropdown
                v-model="id_disaster_reason"
                :options="disasterReasonOptions"
                optionLabel="system_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
              >
                <template #value="disasterReasonOptions">
                  <div v-if="disasterReasonOptions.value">
                    <div>{{ disasterReasonOptions.value.system_name }}</div>
                  </div>
                </template>
                <template #option="disasterReasonOptions">
                  <div>{{ disasterReasonOptions.option.system_name }}</div>
                </template>
              </Dropdown>
            </div> -->
                        <div class="p-field p-col-12 p-lg-8 p-mt-2">
                            <label for="id_disaster_reason_detail">{{ $t('id_disaster_reason') }}<span class="required-input"> </span></label>
                            <InputText
                                id="id_disaster_reason_detail"
                                type="text"
                                v-model="id_disaster_reason_detail"
                                ref="TextBox_6"
                                @keyup.left="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="disasterLevelOptions">{{ $t('id_disaster_level') }}</label>
                            <Dropdown
                                v-model="id_disaster_level"
                                :options="disasterLevelOptions"
                                optionLabel="name"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="disasterLevelOptions">
                                    <div v-if="disasterLevelOptions.value">
                                        <div>{{ disasterLevelOptions.value.name }}</div>
                                    </div>
                                </template>
                                <template #option="disasterLevelOptions">
                                    <div>{{ disasterLevelOptions.option.name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="p-field p-col-12 p-lg-8 p-mt-2">
                            <label for="id_disaster_level_deail">{{ $t('id_disaster_level_deail') }}</label>
                            <InputText
                                id="id_disaster_level_deail"
                                type="text"
                                v-model="id_disaster_level_deail"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="id_disaster_area">{{ $t('id_disaster_area') }}</label>
                            <InputText
                                id="id_disaster_area"
                                type="text"
                                v-model="id_disaster_area"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                            />
                        </div>

                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" -->
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="id_lat">{{ $t('lat') }}</label>
                            <InputText
                                id="id_lat"
                                type="text"
                                v-model="id_lat"
                                @input="inputMap_latlon"
                                ref="TextBox_9"
                                @keyup.left="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                            />
                            <small
                                class="warningLATLON"
                                v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                                >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                                <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                                <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                                <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                                <span> ได้ </span>
                            </small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="id_lon">{{ $t('lon') }}</label>
                            <InputText
                                id="id_lon"
                                type="text"
                                v-model="id_lon"
                                @input="inputMap_latlon"
                                ref="TextBox_10"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_11', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_13', 'Input')"
                            />
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" จบ-->

                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-2 p-mt-4">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(id_lat, id_lon);
                                    sendM_PAT(id_selectedTambon, id_selectedAmphur, id_selectedProvince);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary p-mt-2"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_13', 'Input')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 3/9  -->
                    <!-- <small class="warningLATLON" 
                v-if="this.error_latlon_P || this.error_latlon_A ||   
                this.error_latlon_T || error_latlon_country">ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ 
                <span v-if="this.error_latlon_P || error_latlon_country">
                  จังหวัด
                </span>
                <span v-if="this.error_latlon_A || error_latlon_country">
                  เขต/อำเภอ
                </span>
                <span v-if="this.error_latlon_T || error_latlon_country">
                  แขวง/ตำบล
                </span>
                <span>
                  ได้
                </span>
              
          </small> -->
                    <!-- Doe เพิ่มหมุด map V.2 3/9  จบ-->

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="id_disaster_movement">{{ $t('id_disaster_movement') }}</label>
                            <InputText
                                id="id_disaster_movement"
                                type="text"
                                v-model="id_disaster_movement"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_11', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="id_remark">{{ $t('remark') }}</label>
                            <InputText
                                id="id_remark"
                                type="text"
                                v-model="id_remark"
                                ref="TextBox_13"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Input')"
                            />
                        </div>
                    </div>

                    <hr />
                    <h5>{{ $t('id_disaster_daily') }}</h5>
                    <div class="p-field p-col-12 p-lg-6 p-mt-2">
                        <label for="id_disaster_daily_call">{{ $t('id_disaster_daily_call') }}</label>
                        <InputText
                            id="id_disaster_daily_call"
                            type="text"
                            v-model="id_disaster_daily_call"
                            ref="TextBox_14"
                            @keyup.left="moveFocus($event, 'TextBox_13', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_15', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_12', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_15', 'Button')"
                        />
                    </div>

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="dailyGroup1Options">{{ $t('id_disaster_daily_group1') }}</label>
                            <Dropdown
                                v-model="id_disaster_daily_group1"
                                :options="dailyGroup1Options"
                                @change="someHandler('daily-1')"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="dailyGroup1Options">
                                    <div v-if="dailyGroup1Options.value">
                                        <div>{{ dailyGroup1Options.value.system_name }}</div>
                                    </div>
                                </template>
                                <template #option="dailyGroup1Options">
                                    <div>{{ dailyGroup1Options.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="dailyGroup2Options">{{ $t('id_disaster_daily_group2') }}</label>
                            <Dropdown
                                v-model="id_disaster_daily_group2"
                                :options="dailyGroup2Options"
                                @change="someHandler('daily-2')"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="dailyGroup2Options">
                                    <div v-if="dailyGroup2Options.value">
                                        <div>{{ dailyGroup2Options.value.system_name }}</div>
                                    </div>
                                </template>
                                <template #option="dailyGroup2Options">
                                    <div>{{ dailyGroup2Options.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="dailyGroup3Options">{{ $t('id_disaster_daily_group3') }}</label>
                            <Dropdown
                                v-model="id_disaster_daily_group3"
                                :options="dailyGroup3Options"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="dailyGroup3Options">
                                    <div v-if="dailyGroup3Options.value">
                                        <div>{{ dailyGroup3Options.value.system_name }}</div>
                                    </div>
                                </template>
                                <template #option="dailyGroup3Options">
                                    <div>{{ dailyGroup3Options.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>

                    <hr />
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-10">
                            <label>{{ $t('id_event_file') }}</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-justify-end">
                            <Button
                                @click="eventFileModal = true"
                                icon="pi pi-plus"
                                :label="$t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_15"
                                @keyup.left="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_16', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Button')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="eventFile_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="10"
                                dataKey="id"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="type" :header="$t('id_event_file_type')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.type }}
                                    </template>
                                </Column>
                                <Column field="name" :header="$t('id_event_file_name')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.name }}
                                    </template>
                                </Column>
                                <Column field="detail" :header="$t('id_event_file_detail')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.detail }}
                                    </template>
                                </Column>
                                <Column field="file" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <a :download="`${dataTable.data.name}.${dataTable.data.ext}`" :href="dataTable.data.file"
                                            >ดาวน์โหลด <i class="pi pi-download"></i
                                        ></a>
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        eventFileTable = dataTable.data;
                                                        deleteAt = 'event-file-table';
                                                        alertDisplay(eventFileTable, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <hr />
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-10">
                            <label>{{ $t('id_help') }}</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-justify-end">
                            <Button
                                @click="eventHelpModal = true"
                                icon="pi pi-plus"
                                :label="$t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_16"
                                @keyup.left="moveFocus($event, 'TextBox_15', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_15', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Button')"
                            />
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="eventHelp_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="10"
                                dataKey="id"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="receive" :header="$t('id_help_receive')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.receive }}
                                    </template>
                                </Column>
                                <Column field="work" :header="$t('id_help_work')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.work }}
                                    </template>
                                </Column>
                                <Column field="socialWork" :header="$t('id_help_socialWorker')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.socialWork }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-1 p-mr-5">
                                                <Button
                                                    @click="
                                                        eventHelpModal = true;
                                                        editEventHelpData(dataTable.data);
                                                        eventHelpTable = dataTable.data;
                                                        editAt = 'help-table';
                                                    "
                                                    icon="pi pi-pencil"
                                                    class="p-button-rounded p-button-warning"
                                                />
                                            </div>
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        eventHelpTable = dataTable.data;
                                                        deleteAt = 'help-table';
                                                        alertDisplay(eventHelpTable, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <hr />
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-10">
                            <label>{{ $t('id_operating') }}</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-justify-end">
                            <Button
                                @click="eventOperatingModal = true"
                                icon="pi pi-plus"
                                :label="$t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_17"
                                @keyup.left="moveFocus($event, 'TextBox_16', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_16', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="eventOperating_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="10"
                                dataKey="id"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="operating_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.operating_id }}</div>
                                        <div hidden>{{ dataTable.data.operating_type }}</div>
                                        {{ dataTable.data.operating_name }}
                                    </template>
                                </Column>
                                <Column field="receive" :header="$t('id_operating_receive')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.receive }}
                                    </template>
                                </Column>
                                <Column field="work" :header="$t('id_operating_work')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.work }}
                                    </template>
                                </Column>
                                <Column field="arrive" :header="$t('id_operating_arrive')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.arrive }}
                                    </template>
                                </Column>
                                <Column field="leave" :header="$t('id_operating_leave')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.leave }}
                                    </template>
                                </Column>
                                <Column field="destination" :header="$t('id_operating_destination')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.destination }}
                                    </template>
                                </Column>
                                <Column field="man" :header="$t('id_operating_man')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.man }}
                                    </template>
                                </Column>
                                <Column field="vehicle" :header="$t('id_operating_vehicle')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.vehicle }}
                                    </template>
                                </Column>
                                <Column field="organize" :header="$t('id_operating_mainOrganize')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div v-if="dataTable.data.organize == '1'">
                                            <i class="pi pi-check"></i>
                                        </div>
                                        <div v-else><i class="pi pi-times"></i></div>
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-grid p-col">
                                            <div class="p-field p-col-1 p-mr-5">
                                                <Button
                                                    @click="
                                                        eventOperatingModal = true;
                                                        editEventOperatingData(dataTable.data);
                                                        eventOperatingTable = dataTable.data;
                                                        editAt = 'operating-table';
                                                    "
                                                    icon="pi pi-pencil"
                                                    class="p-button-rounded p-button-warning"
                                                />
                                            </div>
                                            <div class="p-field p-col">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        eventOperatingTable = dataTable.data;
                                                        deleteAt = 'operating-table';
                                                        alertDisplay(eventOperatingTable, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_18"
                    @keyup.left="moveFocus($event, 'TextBox_17', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_17', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_18"
                    @keyup.left="moveFocus($event, 'TextBox_17', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_17', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_19"
                    @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_17', 'Button')"
                />
            </template>
        </Dialog>

        <!-- Manage file event data -->
        <Dialog :modal="true" :visible.sync="eventFileModal" :style="{ width: '500px', overflow: 'auto' }" :header="headerEventFile">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('File_Modal')">
                <label>{{ $t('id_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-field p-col">
                        <label for="id_event_file_name">{{ $t('id_event_file_name') }} <span class="required-input">*</span></label>
                        <InputText
                            id="id_event_file_name"
                            type="text"
                            v-model="id_event_file_name"
                            :class="{
                                'p-invalid': error_id_event_file_name && !id_event_file_name
                            }"
                            ref="TextBox_1_File"
                            @keyup.left="moveFocus($event, 'TextBox_6_File', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_File', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_2_File', 'Input')"
                        />
                        <small class="p-invalid" v-if="error_id_event_file_name && !id_event_file_name">{{
                            $t('id_event_file_name_validate')
                        }}</small>
                    </div>
                    <div class="p-field p-col">
                        <label for="id_event_file_detail">{{ $t('id_event_file_detail') }}</label>
                        <Textarea
                            id="id_event_file_detail"
                            type="text"
                            rows="3"
                            v-model="id_event_file_detail"
                            ref="TextBox_2_File"
                            @keyup.left="moveFocus($event, 'TextBox_1_File', 'Input')"
                            @keyup.right="moveFocus($event, id_fileTypeSelect !== null ? 'TextBox_3_File' : 'TextBox_4_File', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                            @keyup.down="moveFocus($event, id_fileTypeSelect !== null ? 'TextBox_3_File' : 'TextBox_4_File', 'Input')"
                        />
                    </div>
                    <div class="p-field p-col">
                        <label for="id_fileType">{{ $t('id_event_file_type') }} <span class="required-input">*</span></label>
                        <Dropdown
                            v-model="id_fileTypeSelect"
                            :options="fileTypeOptions"
                            optionLabel="name"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :class="{
                                'p-invalid': error_id_fileTypeSelect && !id_fileTypeSelect
                            }"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="fileTypeOptions">
                                <div v-if="fileTypeOptions.value">
                                    <div>{{ fileTypeOptions.value.name }}</div>
                                </div>
                                <span v-else>
                                    {{ fileTypeOptions.placeholder }}
                                </span>
                            </template>
                            <template #option="fileTypeOptions">
                                <div>{{ fileTypeOptions.option.name }}</div>
                            </template>
                        </Dropdown>
                        <small class="p-invalid" v-if="error_id_fileTypeSelect && !id_fileTypeSelect">{{ $t('id_fileTypeSelect_validate') }}</small>
                    </div>

                    <div class="p-col-12">
                        <span hidden>{{ url }}</span>
                        <div class="p-grid">
                            <div class="p-col-9 p-lg-9">
                                <Button
                                    @click="onFileChange"
                                    :disabled="disabledInputFile == 1"
                                    class="p-button-success"
                                    icon="pi pi-plus"
                                    :label="
                                        id_fileTypeSelect == null
                                            ? 'กรุณาเลือกประเภทไฟล์'
                                            : id_fileTypeSelect.id == 'ft_clip'
                                            ? 'เพิ่มคลิป'
                                            : id_fileTypeSelect.id == 'ft_image'
                                            ? 'เพิ่มรูปภาพ'
                                            : id_fileTypeSelect.id == 'ft_other'
                                            ? 'เพิ่มไฟล์อื่นๆ'
                                            : 'กรุณาเลือกประเภทไฟล์'
                                    "
                                    ref="TextBox_3_File"
                                    @keyup.left="moveFocus($event, 'TextBox_2_File', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_File', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_File', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_File', 'Button')"
                                >
                                </Button>

                                <input
                                    style="visibility: hidden; display: none; text-overflow: ellipsis"
                                    :disabled="disabledInputFile == 1"
                                    type="file"
                                    id="id_uploadFile"
                                    @change="onFileChange"
                                    class="inputzone"
                                    :accept="accept"
                                />
                                <!-- <button style="  @click="onFileChange">Choose</button> -->
                            </div>
                            <div class="p-col-3 p-lg-3">
                                <Button
                                    @click="clearFile()"
                                    icon="pi pi-times"
                                    class="p-button-danger"
                                    style="width: auto"
                                    :label="$t('clearImage')"
                                    ref="TextBox_4_File"
                                    @keyup.left="
                                        moveFocus(
                                            $event,
                                            id_fileTypeSelect !== null ? 'TextBox_3_File' : 'TextBox_2_File',
                                            id_fileTypeSelect !== null ? 'Button' : 'Input'
                                        )
                                    "
                                    @keyup.right="moveFocus($event, 'TextBox_5_File', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_File', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_6_File', 'Button')"
                                />
                            </div>
                        </div>
                        <!-- <div id="preview"> {{ pic }} </div> -->
                        <div id="preview">
                            <img v-if="url && id_fileTypeSelect !== null && id_fileTypeSelect.id === 'ft_image'" :src="url" />
                        </div>
                        <div id="event_file_input" ref="event_file_input" hidden></div>
                        <small v-if="url && id_fileTypeSelect !== null">เพิ่มไฟล์แล้ว</small>
                    </div>
                    <!-- <div class="p-col-12">
            <span hidden>{{ url }}</span>
            <div class="p-grid">
              <div class="p-col-8 p-lg-8">
                <Button   @click="onFileChange"
                    :disabled="disabledInputFile == 1"
                    class="p-button-success"
                    icon="pi pi-plus"
                    label="เลือกไฟล์ภาพ"
                    >
                  </Button>

                <input
                style="visibility: hidden;
                           display: none;
                           text-overflow: ellipsis;"
                  :disabled="disabledInputFile == 1"
                  type="file"
                  id="id_uploadFile"
                  @change="onFileChange"
                  class="inputzone"
                  :accept="accept"
                />
              </div>
              <small class="p-invalid p-ml-2" v-if="error_url && !url">{{
                $t("id_fileurl_validate")
              }}</small>
            </div>
            <div class="p-col-3 p-lg-3">
              <Button
                @click="clearFile()"
                icon="pi pi-times"
                class="p-button-danger"
                style="width: auto"
                :label="$t('clearImage')"
              />
            </div>
            <div id="preview">
                
                <img v-if="url" :src="url" />
              </div>
            <div id="event_file_input" ref="event_file_input" hidden></div>
          </div> -->
                </div>
            </div>
            <template #footer>
                <Button
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearSubFileData()"
                    ref="TextBox_5_File"
                    @keyup.left="moveFocus($event, 'TextBox_4_File', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_6_File', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_4_File', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveEventFileData()"
                    ref="TextBox_6_File"
                    @keyup.left="moveFocus($event, 'TextBox_5_File', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_File', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_4_File', 'Button')"
                />
            </template>
        </Dialog>

        <!-- Manage event help data -->
        <Dialog :modal="true" :visible.sync="eventHelpModal" :style="{ width: '500px' }" :header="headerEventHelp">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Help_Modal')">
                <label>{{ $t('id_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12">
                            <label for="id_help_receive">{{ $t('id_help_receive') }} <span class="required-input">*</span></label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :maxDate="id_help_work"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="id_help_receive"
                                v-model="id_help_receive"
                                :showTime="true"
                                :showSeconds="true"
                                :class="{
                                    'p-invalid': error_id_help_receive && !id_help_receive
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_id_help_receive && !id_help_receive">{{ $t('id_help_receive_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12">
                            <label for="id_help_work">{{ $t('id_help_work') }} <span class="required-input">*</span></label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :minDate="id_help_receive"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="id_help_work"
                                v-model="id_help_work"
                                :showTime="true"
                                :showSeconds="true"
                                :class="{ 'p-invalid': error_id_help_work && !id_help_work }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_id_help_work && !id_help_work">{{ $t('id_help_work_validate') }}</small>
                        </div>
                    </div>
                    <div class="p-field p-col">
                        <label for="id_help_socialWorker">{{ $t('id_help_socialWorker') }}</label>

                        <Textarea
                            id="id_help_socialWorker"
                            type="text"
                            rows="3"
                            v-model="id_help_socialWorker"
                            ref="TextBox_1_Help"
                            @keyup.left="moveFocus($event, 'TextBox_3_Help', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_Help', 'Button')"
                            @keyup.down="moveFocus($event, 'TextBox_2_Help', 'Button')"
                        />
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    v-if="editAt == 'help-table'"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="
                        eventHelpModal = false;
                        clearSubHelpData();
                    "
                    ref="TextBox_2_Help"
                    @keyup.left="moveFocus($event, 'TextBox_1_Help', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_3_Help', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_1_Help', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearSubHelpData()"
                    ref="TextBox_2_Help"
                    @keyup.left="moveFocus($event, 'TextBox_1_Help', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_3_Help', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_1_Help', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveEventHelpData()"
                    ref="TextBox_3_Help"
                    @keyup.left="moveFocus($event, 'TextBox_2_Help', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_Help', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_1_Help', 'Input')"
                />
            </template>
        </Dialog>

        <!-- Manage event operating data -->
        <Dialog
            :modal="true"
            :visible.sync="eventOperatingModal"
            :style="{ width: '500px' }"
            :header="headerEventOperating"
            :contentStyle="{ 'overflow-y': 'auto' }"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Operating_Modal')">
                <!-- ! -->

                <!-- ! -->
                <label>{{ $t('id_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-field p-col-12">
                        <label for="id_operating_modal_type">{{ $t('id_operating_modal_type') }} <span class="required-input p-ml-2">*</span></label>
                        <Dropdown
                            v-model="id_operating_modal_type"
                            :options="organizeTypeOptions"
                            @change="someHandler('select-organize-type')"
                            optionLabel="system_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :class="{
                                'p-invalid': error_id_operating_modal_name && !id_operating_modal_name
                            }"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="organizeTypeOptions">
                                <div v-if="organizeTypeOptions.value">
                                    <div>{{ organizeTypeOptions.value.system_name }}</div>
                                </div>
                            </template>
                            <template #option="organizeTypeOptions">
                                <div>{{ organizeTypeOptions.option.system_name }}</div>
                            </template>
                        </Dropdown>
                        <small class="p-invalid" v-if="error_id_operating_modal_type && !id_operating_modal_type">กรุณาเลือกประเภทหน่วยงาน</small>
                    </div>
                    <div class="p-field p-col-12">
                        <label for="id_operating_modal_name">{{ $t('id_operating_modal_name') }} <span class="required-input">*</span></label>
                        <Dropdown
                            v-model="id_operating_modal_name"
                            :options="organizeOptions"
                            optionLabel="organize_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :class="{
                                'p-invalid': error_id_operating_modal_name && !id_operating_modal_name
                            }"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="organizeOptions">
                                <div v-if="organizeOptions.value">
                                    <div>{{ organizeOptions.value.organize_name }}</div>
                                </div>
                            </template>
                            <template #option="organizeOptions">
                                <div>{{ organizeOptions.option.organize_name }}</div>
                            </template>
                        </Dropdown>
                        <small class="p-invalid" v-if="error_id_operating_modal_name && !id_operating_modal_name">{{
                            $t('id_operating_modal_name_validate')
                        }}</small>
                    </div>
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="id_operating_modal_receive">{{ $t('id_operating_modal_receive') }}</label>
                            <Calendar
                                class="p-datepicker2"
                                dateFormat="dd/mm/yy"
                                :maxDate="id_operating_modal_work"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="id_operating_modal_receive"
                                v-model="id_operating_modal_receive"
                                :showTime="true"
                                :showSeconds="true"
                            ></Calendar>
                        </div>
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="id_operating_modal_work">{{ $t('id_operating_modal_work') }}</label>
                            <Calendar
                                :disabled="disabledDate_work == 1"
                                class="p-datepicker2"
                                dateFormat="dd/mm/yy"
                                :minDate="id_operating_modal_receive"
                                :maxDate="id_operating_modal_arrive"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="id_operating_modal_work"
                                v-model="id_operating_modal_work"
                                :showTime="true"
                                :showSeconds="true"
                            ></Calendar>
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="id_operating_modal_arrive">{{ $t('id_operating_modal_arrive') }}</label>
                            <Calendar
                                :disabled="disabledDate_arrive == 1"
                                class="p-datepicker2"
                                dateFormat="dd/mm/yy"
                                :minDate="id_operating_modal_work"
                                :maxDate="id_operating_modal_leave"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="id_operating_modal_arrive"
                                v-model="id_operating_modal_arrive"
                                :showTime="true"
                                :showSeconds="true"
                            ></Calendar>
                        </div>
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="id_operating_modal_leave">{{ $t('id_operating_modal_leave') }}</label>
                            <Calendar
                                :disabled="disabledDate_leave == 1"
                                class="p-datepicker2"
                                dateFormat="dd/mm/yy"
                                :minDate="id_operating_modal_arrive"
                                :maxDate="id_operating_modal_destination"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="id_operating_modal_leave"
                                v-model="id_operating_modal_leave"
                                :showTime="true"
                                :showSeconds="true"
                                style="top: 7px !important"
                            ></Calendar>
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="id_operating_modal_destination">{{ $t('id_operating_modal_destination') }}</label>
                            <Calendar
                                :disabled="disabledDate_dest == 1"
                                class="p-datepicker2"
                                dateFormat="dd/mm/yy"
                                :minDate="id_operating_modal_leave"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="id_operating_modal_destination"
                                v-model="id_operating_modal_destination"
                                :showTime="true"
                                :showSeconds="true"
                            ></Calendar>
                        </div>
                        <div class="p-col-12 p-lg-6 p-mt-3">
                            <label for="id_operating_modal_man">{{ $t('id_operating_modal_man') }}</label>
                            <InputText
                                id="id_operating_modal_man"
                                type="number"
                                min="0"
                                v-model="id_operating_modal_man"
                                ref="TextBox_1_Operating"
                                @keyup.left="moveFocus($event, 'TextBox_4_Operating', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_Operating', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3_Operating', 'Button')"
                            />
                            <!-- TextBox_1_Operating -->
                        </div>
                        <div class="p-col-12 p-lg-6 p-mt-3">
                            <label for="id_operating_modal_vehicle">{{ $t('id_operating_modal_vehicle') }}</label>
                            <InputText
                                id="id_operating_modal_vehicle"
                                type="number"
                                min="0"
                                v-model="id_operating_modal_vehicle"
                                ref="TextBox_2_Operating"
                                @keyup.left="moveFocus($event, 'TextBox_1_Operating', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_Operating', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4_Operating', 'Button')"
                            />
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12 p-justify-end">
                        <div class="p-field-checkbox">
                            <Checkbox
                                id="id_operating_modal_checkMainOrganize"
                                name="id_operating_modal_checkMainOrganize"
                                value="1"
                                v-model="id_operating_modal_checkMainOrganize"
                            />
                            <label for="id_operating_modal_checkMainOrganize">{{ $t('id_operating_modal_checkMainOrganize') }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearSubOperatingData()"
                    ref="TextBox_3_Operating"
                    @keyup.left="moveFocus($event, 'TextBox_2_Operating', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_4_Operating', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_1_Operating', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveEventOperatingData()"
                    ref="TextBox_4_Operating"
                    @keyup.left="moveFocus($event, 'TextBox_3_Operating', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_Operating', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_2_Operating', 'Input')"
                />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '600px', overflow: 'auto' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- Doe เพิ่มหมุด map V.2 4/9  จบ-->
                <!-- Doe : เพิ่ม มุดmap 2/4 จบ -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>
    </div>
</template>

<script>
import organizeTable from '../Report/OrganizeMultiSelectTable.vue';
import mapArea from './Map';
import moment from 'moment';

import textFooter from '../../mixins/textFooter_Search_html';

export default {
    name: 'disaster-information',
    components: {
        organizeTable,
        mapArea,
        textFooter
    },
    data() {
        return {
            dropdownClearFilerValue: 0,
            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            event_name: '',
            disaster_detail: '',
            startDate: null,
            toDate: null,
            disasterTypeOptions: [],
            disasterTypeSelect: null,
            disasterDetailOptions: [],
            disasterDetailSelect: null,
            disasterStatusOptions: [
                { id: 'onworking', name: this.$i18n.t('onworking') },
                { id: 'finish', name: this.$i18n.t('finish') },
                { id: 'notify', name: this.$i18n.t('notify') }
            ],
            disasterStatusSelect: null,
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,
            disaster_location: '',
            showOrganize: false,
            selectedOrganize: {},
            disasterInfo_table: [],
            filters: {},
            temp: null,
            selectedData: '',
            loading: false,

            displayConfirmation: false,
            displayMap: false,

            header: this.$i18n.t('id_modal_title_add'),
            disasterInfoModal: false,
            id_disaster_name: '',
            id_disaster_detail: '',
            id_disasterDate: '',
            id_disasterTypeSelect: null,
            id_disasterDetailSelect: null,
            id_disasterStatusSelect: null,
            id_disasterLocation: '',
            id_selectedProvince: null,
            id_isDisabledAmphur: 1,
            id_selectedAmphur: null,
            id_isDisabledTambon: 1,
            id_selectedTambon: null,
            id_disaster_area: '',

            id_call_name: '',
            id_call_phone: '',
            disasterReasonOptions: [],
            id_disaster_reason: null,
            id_disaster_reason_detail: '',
            disasterLevelOptions: [
                { id: '1', name: '1' },
                { id: '2', name: '2' },
                { id: '3', name: '3' },
                { id: '4', name: '4' },
                { id: '5', name: '5' }
            ],
            id_disaster_level: null,
            id_disaster_level_deail: '',
            id_lat: '',
            id_lon: '',
            id_disaster_movement: '',
            id_remark: '',
            id_disaster_daily_call: '',

            dailyGroup1Options: [],
            dailyGroup2Options: [],
            dailyGroup3Options: [],
            id_disaster_daily_group1: null,
            id_disaster_daily_group2: null,
            id_disaster_daily_group3: null,

            eventFile_table: [],
            eventHelp_table: [],
            eventOperating_table: [],

            error_id_disaster_name: false,
            error_id_disasterTypeSelect: false,
            error_id_selectedProvince: false,
            error_id_selectedAmphur: false,
            error_id_selectedTambon: false,
            error_id_operating_modal_type: false,
            error_id_operating_modal_name: false,

            headerEventFile: this.$i18n.t('id_event_file_modal_title_add'),
            eventFileModal: false,
            id_event_file_name: '',
            id_event_file_detail: '',
            fileTypeOptions: [
                { id: 'ft_clip', name: this.$i18n.t('ft_clip') },
                { id: 'ft_image', name: this.$i18n.t('ft_image') },
                { id: 'ft_other', name: this.$i18n.t('ft_other') }
            ],
            id_fileTypeSelect: null,
            accept: null,
            url: null,
            download_ext: '',
            disabledInputFile: 1,
            error_id_event_file_name: false,
            error_id_fileTypeSelect: false,
            error_url: false,

            headerEventHelp: this.$i18n.t('id_help_modal_title_add'),
            eventHelpModal: false,
            id_help_receive: null,
            id_help_work: null,
            id_help_socialWorker: '',
            error_id_help_receive: false,
            error_id_help_work: false,

            headerEventOperating: this.$i18n.t('id_operating_modal_title_add'),
            eventOperatingModal: false,
            organizeTypeOptions: [],
            organizeOptions: [],
            id_operating_modal_id: '',
            id_operating_modal_type: null,
            id_operating_modal_name: null,
            id_operating_modal_receive: null,
            id_operating_modal_work: null,
            id_operating_modal_arrive: null,
            id_operating_modal_leave: null,
            id_operating_modal_destination: null,
            disabledDate_work: 1,
            disabledDate_arrive: 1,
            disabledDate_leave: 1,
            disabledDate_dest: 1,
            id_operating_modal_man: 0,
            id_operating_modal_vehicle: 0,
            id_operating_modal_checkMainOrganize: [],

            deleteAt: '',
            editAt: '',
            eventFileTable: {},
            eventHelpTable: {},
            eventOperatingTable: {},
            temp_organize_id: '',

            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            provinceEKanit: '',
            amphurEKanit: '',
            tambonEKanit: '',
            // เพิ่ม มุดmap 3/4
            //  Doe เพิ่มหมุด map V.2 5/9  -->
            latlon: {},
            PAT: {},
            FSS: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            iP: 0,
            iA: 0,
            //  Doe เพิ่มหมุด map V.2 5/9  จบ-->
            // เพิ่ม มุดmap 3/4 จบ

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            date_create_form: '',
            date_update_form: '',
            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานหลัก',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อเหตุการณ์',
                    textShow: ''
                },
                {
                    DataName: 'จากวันที่',
                    textShow: ''
                },
                {
                    DataName: 'ถึงวันที่',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทสาธารณภัย',
                    textShow: ''
                },
                {
                    DataName: 'สถานะเหตุการณ์',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                },
                {
                    DataName: 'สถานที่เกิดเหตุ',
                    textShow: ''
                },
                {
                    DataName: 'ลักษณะที่เกิดเหตุ',
                    textShow: ''
                }
            ]
        };
    },
    watch: {
        async disasterInfoModal(val) {
            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.id_disaster_name != '' &&
                    this.id_disasterTypeSelect != null &&
                    this.id_selectedProvince != null
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.disasterInfoModal = false;
                            this.clearData();
                        } else {
                            this.disasterInfoModal = true;
                        }
                    });
                } else {
                    // this.clearData();
                    this.disasterStatusOptions = [
                        { id: 'getall', name: this.$i18n.t('selectAll') },
                        { id: 'onworking', name: this.$i18n.t('onworking') },
                        { id: 'finish', name: this.$i18n.t('finish') },
                        { id: 'notify', name: this.$i18n.t('notify') }
                    ];
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterTypeOptions = response.data.data),
                                this.disasterTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });
                    this.clearData();
                }
            } else {
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-province' }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => (this.disasterTypeOptions = response.data.data));
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-01' }
                    })
                    .then((response) => (this.organizeTypeOptions = response.data.data));
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-15' }
                    })
                    .then((response) => (this.dailyGroup1Options = response.data.data));
                this.disasterStatusOptions = [
                    { id: 'onworking', name: this.$i18n.t('onworking') },
                    { id: 'finish', name: this.$i18n.t('finish') },
                    { id: 'notify', name: this.$i18n.t('notify') }
                ];
                if (this.selectedData == '') {
                    this.id_disasterStatusSelect = {
                        id: 'onworking',
                        name: this.$i18n.t('onworking')
                    };
                    this.id_disaster_level = { id: '1', name: '1' };
                }

                if (this.temp === null) {
                    this.date_create_form = this.checkDate_showEN(new Date());
                    this.date_update_form = this.checkDate_showEN(new Date());
                }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.disasterInfoModal = true;
            }
        },

        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-amphur', province_id: val.province_id }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-tambon', amphur_id: val.amphur_id }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        async id_selectedProvince(val) {
            if (val != null) {
                this.id_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-amphur', province_id: val.province_id }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
            } else {
                this.id_isDisabledAmphur = 1;
                this.id_selectedAmphur = null;
            }
        },

        async id_selectedAmphur(val) {
            if (val != null) {
                this.id_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-tambon', amphur_id: val.amphur_id }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
            } else {
                this.id_isDisabledTambon = 1;
                this.id_selectedTambon = null;
            }
        },

        async disasterTypeSelect(val) {
            if (val != null) {
                this.disasterDetailSelect = null;
                await this.axios
                    .post(`${this.$url_service}/get/datagroup`, {
                        body: { topic: 'get-detail-disaster', id: val.system_id }
                    })
                    .then((response) => {
                        (this.disasterDetailOptions = response.data.data),
                            this.disasterDetailOptions.splice(0, 0, {
                                system_id: 'getall',
                                system_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.disasterDetailOptions = [];
                this.disasterDetailSelect = null;
            }
        },

        async id_disasterTypeSelect(val) {
            if (val != null) {
                await this.axios
                    .post(`${this.$url_service}/get/datagroup`, {
                        body: { topic: 'get-detail-disaster', id: val.system_id }
                    })
                    .then((response) => (this.disasterDetailOptions = response.data.data));
                await this.axios
                    .post(`${this.$url_service}/get/datagroup`, {
                        body: { topic: 'get-cause-disaster', id: val.system_id }
                    })
                    .then((response) => (this.disasterReasonOptions = response.data.data));
            } else {
                this.disasterDetailOptions = [];
                this.id_disasterTypeSelect = null;

                this.disasterReasonOptions = [];
                this.id_disaster_reason = null;
            }
        },

        async id_disaster_daily_group1(val) {
            if (val != null) {
                await this.axios
                    .post(`${this.$url_service}/get/datagroup`, {
                        body: { topic: 'get-daily-option', group: val.system_id }
                    })
                    .then((response) => (this.dailyGroup2Options = response.data.data));
            } else {
                this.dailyGroup2Options = [];
            }
        },

        async id_disaster_daily_group2(val) {
            if (val != null) {
                await this.axios
                    .post(`${this.$url_service}/get/datagroup`, {
                        body: { topic: 'get-daily-option', group: val.system_id }
                    })
                    .then((response) => (this.dailyGroup3Options = response.data.data));
            } else {
                this.dailyGroup3Options = [];
            }
        },

        async id_operating_modal_type(val) {
            if (val != null) {
                await this.axios
                    .post(`${this.$url_service}/initial/organize`, {
                        body: { topic: 'get-option-from-type', id: val.system_id }
                    })
                    .then((response) => (this.organizeOptions = response.data.data));
            } else {
                this.organizeOptions = [];
                this.id_operating_modal_name = null;
            }
        },

        selectedData(val) {
            if (val != '') {
                if (val.disaster_detail != 'null') {
                    this.id_disasterDetailSelect = {
                        system_id: val.detail_id,
                        system_name: val.detail_name
                    };
                } else {
                    this.id_disasterDetailSelect = null;
                }

                if (val.event_cause_id != 'null') {
                    this.id_disaster_reason = {
                        system_id: val.cause_id,
                        system_name: val.cause_name
                    };
                } else {
                    this.id_disaster_reason = null;
                }

                if (val.daily_group_1 != 'null') {
                    this.id_disaster_daily_group1 = {
                        system_id: val.group1_id,
                        system_name: val.group1_name
                    };
                } else {
                    this.id_disaster_daily_group1 = null;
                }

                if (val.daily_group_2 != 'null') {
                    this.id_disaster_daily_group2 = {
                        system_id: val.group2_id,
                        system_name: val.group2_name
                    };
                } else {
                    this.id_disaster_daily_group2 = null;
                }

                if (val.daily_group_3 != 'null') {
                    this.id_disaster_daily_group3 = {
                        system_id: val.group3_id,
                        system_name: val.group3_name
                    };
                } else {
                    this.id_disaster_daily_group3 = null;
                }

                //For adding data from map disaster
                if (val.location_id == 'null') {
                    this.id_selectedProvince = null;
                }
                const locate_id = val.location_id.split('');
                if (val.event_detail != 'null' || val.event_detail != '') {
                    if (val.event_detail.includes('{')) {
                        var jsonData = JSON.parse(val.event_detail);

                        this.provinceEKanit = jsonData.locate.PROV_TNAME;
                        this.amphurEKanit = jsonData.locate.AMP_TNAME;
                        this.tambonEKanit = jsonData.locate.TAM_TNAME;

                        this.id_selectedProvince = {
                            province_id: `${locate_id[0]}${locate_id[1]}`,
                            province_name: this.provinceEKanit
                        };
                        this.id_selectedAmphur = {
                            amphur_id: `${locate_id[0]}${locate_id[1]}${locate_id[2]}${locate_id[3]}`,
                            amphur_name: this.tambonEKanit
                        };
                        this.id_selectedTambon = {
                            tambon_id: val.location_id,
                            tambon_name: this.tambonEKanit
                        };

                        this.id_remark = 'ข้อมูลจาก eKanit';
                    } else {
                        this.id_remark = val.event_detail;
                    }
                }
            }
        },

        disasterInfo_table(val) {
            if (val.length > 0) {
                this.loading = false;
            } else {
                this.loading = false;
            }
        },

        id_fileTypeSelect(val) {
            this.url = null;
            if (val != null) {
                this.disabledInputFile = 0;
                if (val.id == 'ft_clip') {
                    this.accept = 'video/*';
                }
                if (val.id == 'ft_image') {
                    this.accept = 'image/*';
                }
                if (val.id == 'ft_other') {
                    this.accept = '';
                }
            } else {
                this.disabledInputFile = 1;
            }
        },

        startDate(val) {
            if (val == null) {
                this.toDate = null;
            }
        },

        id_help_receive(val) {
            if (val == null) {
                this.id_help_work = null;
            }
        },

        id_operating_modal_receive(val) {
            if (val == null) {
                this.id_operating_modal_work = null;
                this.disabledDate_work = 1;
            } else {
                this.disabledDate_work = 0;
            }
        },
        id_operating_modal_work(val) {
            if (val == null) {
                this.id_operating_modal_arrive = null;
                this.disabledDate_arrive = 1;
            } else {
                this.disabledDate_arrive = 0;
            }
        },
        id_operating_modal_arrive(val) {
            if (val == null) {
                this.id_operating_modal_leave = null;
                this.disabledDate_leave = 1;
            } else {
                this.disabledDate_leave = 0;
            }
        },
        id_operating_modal_leave(val) {
            if (val == null) {
                this.id_operating_modal_destination = null;
                this.disabledDate_dest = 1;
            } else {
                this.disabledDate_dest = 0;
            }
        },

        eventOperatingModal(val) {
            if (val == false) {
                this.clearSubOperatingData();
            } else {
                this.FocusRef_delay('TextBox_1_Operating', 'Input');
            }
        },

        eventFileModal(val) {
            if (val == false) {
                this.clearSubFileData();
            } else {
                this.FocusRef_delay('TextBox_1_File', 'Input');
            }
        },

        eventHelpModal(val) {
            if (val == false) {
                this.clearSubHelpData();
            } else {
                this.FocusRef_delay('TextBox_1_Help', 'Input');
            }
        },

        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        }
    },
    created() {
        // this.initialData();
        console.log('d');
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        this.searchMenu();
        this.checkRole = JSON.parse(localStorage.getItem('data')).permission_id;

        this.checkView_data = JSON.parse(localStorage.getItem('data')).view_data;
        this.checkAdd_data = JSON.parse(localStorage.getItem('data')).add_data;
        this.checkEdit_data = JSON.parse(localStorage.getItem('data')).edit_data;
        this.checkDelete_data = JSON.parse(localStorage.getItem('data')).delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_5_search') && !this.isFocused('TextBox_6_search')) {
                    this.searchDisasterInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    this.eventFileModal === false &&
                    this.eventHelpModal === false &&
                    this.eventOperatingModal === false &&
                    !this.isFocused('TextBox_11') &&
                    !this.isFocused('TextBox_15') &&
                    !this.isFocused('TextBox_16') &&
                    !this.isFocused('TextBox_17') &&
                    !this.isFocused('TextBox_18') &&
                    !this.isFocused('TextBox_19')
                ) {
                    this.saveData();
                }
            } else if (ModalName === 'File_Modal') {
                if (
                    !this.isFocused('TextBox_3_File') &&
                    !this.isFocused('TextBox_4_File') &&
                    !this.isFocused('TextBox_5_File') &&
                    !this.isFocused('TextBox_6_File')
                ) {
                    this.saveEventFileData();
                }
            } else if (ModalName === 'Help_Modal') {
                if (!this.isFocused('TextBox_2_Help') && !this.isFocused('TextBox_3_Help')) {
                    this.saveEventHelpData();
                }
            } else if (ModalName === 'Operating_Modal') {
                if (!this.isFocused('TextBox_3_Operating') && !this.isFocused('TextBox_4_Operating')) {
                    this.saveEventOperatingData();
                }
            }
        },
        handleResize() {
            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            this.disasterStatusOptions = [
                { id: 'getall', name: this.$i18n.t('selectAll') },
                { id: 'onworking', name: this.$i18n.t('onworking') },
                { id: 'finish', name: this.$i18n.t('finish') },
                { id: 'notify', name: this.$i18n.t('notify') }
            ];
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: {
                        group: 'dg-02'
                    }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
        },
        async initialData() {
            this.filters = {};
            this.loading = true;
            this.disasterStatusOptions = [
                { id: 'getall', name: this.$i18n.t('selectAll') },
                { id: 'onworking', name: this.$i18n.t('onworking') },
                { id: 'finish', name: this.$i18n.t('finish') },
                { id: 'notify', name: this.$i18n.t('notify') }
            ];
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: {
                        group: 'dg-02'
                    }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/disaster`, {
                    body: {
                        topic: 'get-table'
                        // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
                    }
                })
                .then((response) => {
                    this.disasterInfo_table = response.data.data;

                    this.formatData(this.disasterInfo_table);
                    // console.log(this.disasterInfo_table)
                });
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                data[index]['index'] = index + 1;
                if (data[index].event_date_alias) {
                    const element = data[index].event_date_alias.split('/');

                    let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);

                    data[index].event_date_alias = moment(dateNew).locale('th').add(543, 'year').format('LLL');
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        acceptNumberPhone() {
            var x = this.id_call_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.id_call_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },

        closeAllModal() {
            // console.log("Close and don`t save data");
            this.disasterInfoModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        someHandler(message) {
            if (message == 'daily-1') {
                this.id_disaster_daily_group2 = null;
                this.id_disaster_daily_group3 = null;
            }
            if (message == 'daily-2') {
                this.id_disaster_daily_group3 = null;
            }
            if (message == 'disaster-type') {
                this.id_disasterDetailSelect = null;
                this.id_disaster_reason = null;
            }
            if (message == 'select-province') {
                this.id_selectedAmphur = null;
            }
            if (message == 'select-amphur') {
                this.id_selectedTambon = null;
            }
            if (message == 'select-organize-type') {
                this.id_operating_modal_name = null;
            }
        },

        clearFile() {
            this.url = null;
            document.getElementById('id_uploadFile').value = '';
        },

        onFileChange(e) {
            var reader;
            document.getElementById('id_uploadFile').click();
            if (e.type === 'click') {
                this.url = null;
            } else {
                if (e.target.files[0] != undefined) {
                    const imgSize = e.target.files[0];
                    if (imgSize.size > 7340032) {
                        this.$fire({
                            type: 'warning',
                            title: 'ขนาดไฟล์ใหญ่เกินไป',
                            text: 'กรุณาใส่เฉพาะไฟล์ไม่เกิน 7 MB.',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        // this.clearImage()
                    } else {
                        if (this.id_fileTypeSelect.id == 'ft_image') {
                            if (e.target.files[0].type.split('/')[0] == 'image') {
                                this.download_ext = e.target.files[0].type.split('/')[1];
                                const file = e.target.files[0];
                                this.url = URL.createObjectURL(file);
                                reader = new FileReader();
                                reader.onload = (e) => {
                                    var img = document.createElement('img');
                                    img.onload = () => {
                                        var canvas = document.createElement('canvas');
                                        var ctx = canvas.getContext('2d');
                                        ctx.drawImage(img, 0, 0);

                                        var MAX_WIDTH = 800;
                                        var MAX_HEIGHT = 800;
                                        var width = img.width;
                                        var height = img.height;

                                        if (width > height) {
                                            if (width > MAX_WIDTH) {
                                                height *= MAX_WIDTH / width;
                                                width = MAX_WIDTH;
                                            }
                                        } else {
                                            if (height > MAX_HEIGHT) {
                                                width *= MAX_HEIGHT / height;
                                                height = MAX_HEIGHT;
                                            }
                                        }
                                        canvas.width = width;
                                        canvas.height = height;
                                        ctx = canvas.getContext('2d');
                                        ctx.drawImage(img, 0, 0, width, height);

                                        let console = {};
                                        let logger = document.getElementById('event_file_input');
                                        console.log = (text) => {
                                            let txt = document.createTextNode(text);
                                            logger.appendChild(txt);
                                        };
                                        console.log(e.target.result);
                                    };
                                    img.src = e.target.result;
                                };
                                reader.readAsDataURL(file);
                            } else {
                                // this.$toast.add({
                                //   severity: "error",
                                //   summary: "ประเภทไฟล์ผิดพลาด",
                                //   detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
                                //   life: 3000,
                                // });
                                this.$fire({
                                    title: 'ประเภทไฟล์ผิดพลาด',
                                    text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                                    type: 'error',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                                this.url = null;
                                document.getElementById('id_uploadFile').value = '';
                            }
                        }
                        if (this.id_fileTypeSelect.id == 'ft_clip') {
                            this.download_ext = e.target.files[0].type.split('/')[1];
                            if (e.target.files[0].type.split('/')[0] == 'video') {
                                const file = e.target.files[0];
                                this.url = URL.createObjectURL(file);
                                reader = new FileReader();
                                reader.onload = (e) => {
                                    let console = {};
                                    let logger = document.getElementById('event_file_input');
                                    console.log = (text) => {
                                        let txt = document.createTextNode(text);
                                        logger.appendChild(txt);
                                    };
                                    console.log(e.target.result);
                                };
                                reader.readAsDataURL(file);
                            } else {
                                // this.$toast.add({
                                //   severity: "error",
                                //   summary: "ประเภทไฟล์ผิดพลาด",
                                //   detail: "กรุณาใส่เฉพาะไฟล์วิดีโอเท่านั้น",
                                //   life: 3000,
                                // });
                                this.$fire({
                                    title: 'ประเภทไฟล์ผิดพลาด',
                                    text: 'กรุณาใส่เฉพาะไฟล์วิดีโอเท่านั้น',
                                    type: 'error',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                                this.url = null;
                                document.getElementById('id_uploadFile').value = '';
                            }
                        }
                        if (this.id_fileTypeSelect.id == 'ft_other') {
                            //pdf => .split('/')[1] == 'pdf' => .pdf
                            //excel => .split('/')[1] == 'vnd.ms-excel' => .xls
                            //word => .split('/')[1] == 'vnd.openxmlformats-officedocument.wordprocessingml.document' => .docx
                            //exe => .split('/')[1] == 'x-zip-compressed || x-msdownload' => .exe
                            //javascript => .split('/')[1] == 'javascript' => .js
                            //html => .split('/')[1] == 'html' => .html
                            //css => .split('/')[1] == 'css' => .css
                            // console.log(e.target.files[0]);
                            if (e.target.files[0].type.split('/')[1] == 'pdf') {
                                this.download_ext = 'pdf';
                            }
                            if (
                                e.target.files[0].type.split('/')[1] == 'vnd.ms-excel' ||
                                e.target.files[0].type.split('/')[1] == 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            ) {
                                this.download_ext = 'xls';
                            }
                            if (e.target.files[0].type.split('/')[1] == 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
                                this.download_ext = 'doc';
                            }
                            if (e.target.files[0].type.split('/')[1] == 'x-zip-compressed') {
                                this.download_ext = 'zip';
                            }
                            if (e.target.files[0].type.split('/')[1] == 'x-msdownload') {
                                this.download_ext = 'exe';
                            }
                            if (e.target.files[0].type.split('/')[1] == 'javascript') {
                                this.download_ext = 'js';
                            }
                            if (e.target.files[0].type.split('/')[1] == 'html') {
                                this.download_ext = 'html';
                            }
                            if (e.target.files[0].type.split('/')[1] == 'css') {
                                this.download_ext = 'css';
                            }

                            const file = e.target.files[0];
                            this.url = URL.createObjectURL(file);
                            reader = new FileReader();
                            reader.onload = (e) => {
                                let console = {};
                                let logger = document.getElementById('event_file_input');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                console.log(e.target.result);
                            };
                            reader.readAsDataURL(file);
                        }
                    }
                } else {
                    this.url = null;
                }
            }
        },

        // selectedOrganize_passValue(variable) {
        //   this.showOrganize = false;
        //   this.selectedOrganize = {
        //     id: variable.organize_id,
        //     name: variable.organize_name,
        //   };
        // },

        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                this.organize_table = [];
                for (let i = 0; i < variable.length; i++) {
                    this.organize_table.push({
                        organize_id: variable[i].organize_id,
                        organize_name: variable[i].organize_name
                    });
                }
            }
        },

        selectMap_passValue(variable) {
            // this.displayMap = false;
            this.id_lat = variable.lat;
            this.id_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.iie_lat",this.iie_lat)
            // console.log("this.iie_lon",this.iie_lon)
            if (this.id_lat !== null && this.id_lon !== null && this.id_lat !== '' && this.id_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/9  -->
        async inputMap_latlon() {
            if (this.id_lat !== '' && this.id_lat !== null && this.id_lon !== '' && this.id_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.id_lat}/lon=${this.id_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.id_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.id_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.id_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.id_selectedProvince = null;
                                this.id_selectedAmphur = null;
                                this.id_selectedTambon = null;
                            }

                            // console.log("this.id_selectedProvince",this.id_selectedProvince)
                            // console.log("this.id_selectedAmphur",this.id_selectedAmphur)
                            // console.log("this.id_selectedTambon",this.id_selectedTambon)
                        } else {
                            this.id_selectedProvince = null;
                            this.id_selectedAmphur = null;
                            this.id_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.id_selectedProvince = null;
                this.id_selectedAmphur = null;
                this.id_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.id_selectedProvince",this.id_selectedProvince)
            //   console.log("this.id_selectedAmphur",this.id_selectedAmphur)
            //   console.log("this.id_selectedTambon",this.id_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';

            if (this.id_selectedProvince) {
                this.sP.push(this.id_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.id_selectedAmphur) {
                this.sA.push(this.id_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            // if (this.ifh_FireStationSelected) {
            //   await this.axios.post(url,{
            // 				"key":"78e731027d8fd50ed642340b7c9a63b3",
            // 				"topic": "fireStation",
            // 				"type":"point",
            // 				"name":this.ifh_FireStationSelected.fs_tname
            // 			})
            // 			.then((response) => {
            // 				let getData = response.data.data

            // 				const lon = getData.features[0].geometry.coordinates[0];
            // 				const lat = getData.features[0].geometry.coordinates[1];

            //         // const PAT_Tambon = this.ifh_FireStationSelected.tambon_name
            // 				// const PAT_Amphoe = this.ifh_FireStationSelected.amphur_name
            // 				// const PAT_province = this.ifh_FireStationSelected.province_name

            //         // console.log("PAT_Tambon",PAT_Tambon)
            //         // console.log("PAT_Amphoe",PAT_Amphoe)
            //         // console.log("PAT_province",PAT_province)
            //         this.id_lat = lat
            //         this.id_lon = lon

            //         this.error_latlon_P = false
            //         this.error_latlon_A = false
            //         this.error_latlon_T = false

            // 			})
            // }
            // else
            if (this.id_selectedProvince == null) {
                this.id_lat = '';
                this.id_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.id_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.id_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.id_lat = lat;
                        this.id_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.id_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.id_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.id_lat = lat;
                        this.id_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.id_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.id_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.id_lat = lat;
                        this.id_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                // if (this.ifh_FireStationSelected) {
                // 	await this.axios.post(url,{
                // 			"key":"78e731027d8fd50ed642340b7c9a63b3",
                // 			"topic": "fireStation",
                // 			"type":"point",
                // 			"name":this.ifh_FireStationSelected.fs_tname
                // 		})
                // 		.then((response) => {
                // 			let getData = response.data.data

                // 			const lon = getData.features[0].geometry.coordinates[0];
                // 			const lat = getData.features[0].geometry.coordinates[1];

                //       this.id_lat = lat
                //       this.id_lon = lon

                //       this.error_latlon_P = false
                //       this.error_latlon_A = false
                //       this.error_latlon_T = false

                // 		})
                // }else
                if (this.id_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.id_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.id_lat = lat;
                            this.id_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.id_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.id_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.id_lat = lat;
                            this.id_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.id_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.id_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.id_lat = lat;
                            this.id_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.id_lat = '';
                    this.id_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/9  จบ-->

        async searchDisasterInfo() {
            // this.filters={}
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            this.loading = true;
            // var start_date, to_date;
            // if (this.startDate != null) {
            //   const start = new Date(this.startDate);
            //   const ye_s = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            //     start
            //   );
            //   const mo_s = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            //     start
            //   );
            //   const da_s = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            //     start
            //   );
            //   start_date = `${ye_s}-${mo_s}-${da_s}`;
            // } else {
            //   start_date = "";
            // }

            // if (this.toDate != null) {
            //   const to = new Date(this.toDate);
            //   const ye_t = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            //     to
            //   );
            //   const mo_t = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            //     to
            //   );
            //   const da_t = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            //     to
            //   );
            //   to_date = `${ye_t}-${mo_t}-${da_t}`;
            // } else {
            //   to_date = "";
            // }
            const reportEvent_startTime = new Date(moment().set({ hour: 0, minute: 0, second: 0 }));
            const reportEvent_endTime = new Date(moment().set({ hour: 23, minute: 59, second: 59 }));

            let New_start_date = null;
            if (this.startDate != null) {
                New_start_date = `${moment(this.startDate).format('YYYY-MM-DD')} ${moment(reportEvent_startTime).format('HH:mm:ss')}`;
            } else {
                New_start_date = null;
            }

            let New_to_Date = null;
            if (this.toDate != null) {
                New_to_Date = `${moment(this.toDate).format('YYYY-MM-DD')} ${moment(reportEvent_endTime).format('HH:mm:ss')}`;
            } else {
                New_to_Date = null;
            }

            // console.log("New_start_date",New_start_date)
            // console.log("this.organize_table",this.organize_table)

            await this.axios
                .post(`${this.$url_service}/disaster`, {
                    body: {
                        topic: 'search-table',
                        name: this.event_name,
                        // startdate: start_date,
                        // todate: to_date,
                        startdate: New_start_date == null ? (New_start_date = '') : New_start_date,
                        todate: New_to_Date == null ? (New_to_Date = '') : New_to_Date,
                        disaster: this.disasterTypeSelect,
                        // detail: this.disasterDetailSelect,
                        detail: this.disaster_detail,
                        status: this.disasterStatusSelect,
                        province: this.selectedProvince,
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        location: this.disaster_location,
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลัก
                        organize: this.organize_table
                        // userOrg: this.checkPermission() ? null : this.getUserOrganize(), //เช็คสิทธิ์
                    }
                })
                .then((response) => {
                    (this.loading = false), (this.disasterInfo_table = response.data.data);

                    this.formatData(this.disasterInfo_table);
                    // console.log("this.disasterInfo_table",this.disasterInfo_table)

                    this.setSearchText_Footer();
                });
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.event_name !== '' ||
                this.checkDateNull_String(this.startDate) ||
                this.checkDateNull_String(this.toDate) ||
                this.disasterTypeSelect !== null ||
                this.disasterStatusSelect !== null ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null ||
                this.disaster_location !== '' ||
                this.disaster_detail !== ''
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานหลัก' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อเหตุการณ์' && this.event_name !== '') {
                        element.textShow = this.event_name;
                    }
                    if (element.DataName === 'จากวันที่' && this.startDate !== null && this.startDate !== '') {
                        element.textShow = this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.startDate)), 'string');
                    }
                    if (element.DataName === 'ถึงวันที่' && this.toDate !== null && this.toDate !== '') {
                        element.textShow = this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.toDate)), 'string');
                    }
                    if (element.DataName === 'ประเภทสาธารณภัย' && this.disasterTypeSelect !== null) {
                        element.textShow = this.disasterTypeSelect.system_name;
                    }
                    if (element.DataName === 'สถานะเหตุการณ์' && this.disasterStatusSelect !== null) {
                        element.textShow = this.disasterStatusSelect.name;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                    if (element.DataName === 'สถานที่เกิดเหตุ' && this.disaster_location !== '') {
                        element.textShow = this.disaster_location;
                    }
                    if (element.DataName === 'ลักษณะที่เกิดเหตุ' && this.disaster_detail !== '') {
                        element.textShow = this.disaster_detail;
                    }
                }
                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        checkDateNull_String(info) {
            if (typeof info === 'object' && info !== null) {
                return true;
            } else {
                if (info !== null && info !== '' && info.length === 10) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        saveEventFileData() {
            if (this.id_event_file_name == '' || this.id_fileTypeSelect == null || this.url == null) {
                if (this.id_event_file_name == '') {
                    this.error_id_event_file_name = true;
                }
                if (this.id_fileTypeSelect == null) {
                    this.error_id_fileTypeSelect = true;
                }
                if (this.url == null) {
                    this.error_url = true;
                }
            } else {
                // console.log("Save file event");
                this.eventFileModal = false;
                this.eventFile_table.push({
                    type: this.id_fileTypeSelect.name,
                    name: this.id_event_file_name,
                    detail: this.id_event_file_detail,
                    file: this.$refs.event_file_input.innerText,
                    ext: this.download_ext
                });
                this.clearSubFileData();
            }
        },

        saveEventHelpData() {
            if (this.id_help_receive == null || this.id_help_work == null) {
                if (this.id_help_receive == null) {
                    this.error_id_help_receive = true;
                }
                if (this.id_help_work == null) {
                    this.error_id_help_work = true;
                }
            } else {
                var time = [this.id_help_receive, this.id_help_work];
                for (let i = 0; i < 2; i++) {
                    const help = new Date(time[i]);
                    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(help);
                    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(help);
                    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(help);
                    const h = help.getHours();
                    const m = help.getMinutes();
                    const s = help.getSeconds();
                    time[i] = `${ye}-${mo}-${da} ${h}:${m}:${s}`;
                }

                this.eventHelpModal = false;
                if (this.editAt == 'help-table') {
                    this.eventHelp_table = this.eventHelp_table.filter((val) => val !== this.eventHelpTable);
                    this.eventHelp_table.push({
                        receive: time[0],
                        work: time[1],
                        socialWork: this.id_help_socialWorker
                    });
                } else {
                    // console.log("Save help event");
                    this.eventHelp_table.push({
                        receive: time[0],
                        work: time[1],
                        socialWork: this.id_help_socialWorker
                    });
                }
                this.clearSubHelpData();
            }
        },

        saveEventOperatingData() {
            if (this.id_operating_modal_type == null || this.id_operating_modal_name == null) {
                if (this.id_operating_modal_type == null) {
                    this.error_id_operating_modal_type = true;
                }
                if (this.id_operating_modal_name == null) {
                    this.error_id_operating_modal_name = true;
                }
            } else {
                var time = [
                    this.id_operating_modal_receive,
                    this.id_operating_modal_work,
                    this.id_operating_modal_arrive,
                    this.id_operating_modal_leave,
                    this.id_operating_modal_destination
                ];
                for (let i = 0; i < 5; i++) {
                    if (time[i] != null) {
                        const operating = new Date(time[i]);
                        const ye = new Intl.DateTimeFormat('en', {
                            year: 'numeric'
                        }).format(operating);
                        const mo = new Intl.DateTimeFormat('en', {
                            month: '2-digit'
                        }).format(operating);
                        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(operating);
                        const h = operating.getHours();
                        const m = operating.getMinutes();
                        const s = operating.getSeconds();
                        time[i] = `${ye}-${mo}-${da} ${h}:${m}:${s}`;
                    } else {
                        time[i] = '-';
                    }
                }

                this.eventOperatingModal = false;
                if (this.editAt == 'operating-table') {
                    this.eventOperating_table = this.eventOperating_table.filter((val) => val !== this.eventOperatingTable);
                    this.eventOperating_table.push({
                        operating_id: this.temp_organize_id,
                        operating_type: this.id_operating_modal_type.system_name,
                        operating_name: this.id_operating_modal_name.organize_name,
                        receive: time[0],
                        work: time[1],
                        arrive: time[2],
                        leave: time[3],
                        destination: time[4],
                        man: this.id_operating_modal_man,
                        vehicle: this.id_operating_modal_vehicle,
                        organize: this.id_operating_modal_checkMainOrganize
                    });
                } else {
                    // console.log("Save operating");
                    this.eventOperating_table.push({
                        operating_id: this.id_operating_modal_name.organize_id,
                        operating_type: this.id_operating_modal_type.system_name,
                        operating_name: this.id_operating_modal_name.organize_name,
                        receive: time[0],
                        work: time[1],
                        arrive: time[2],
                        leave: time[3],
                        destination: time[4],
                        man: this.id_operating_modal_man,
                        vehicle: this.id_operating_modal_vehicle,
                        organize: this.id_operating_modal_checkMainOrganize
                    });
                }
            }
        },

        async confirmDelete() {
            if (this.deleteAt == 'event-file-table') {
                this.eventFile_table = this.eventFile_table.filter((val) => val !== this.eventFileTable);
                this.displayConfirmation = false;
            } else if (this.deleteAt == 'help-table') {
                this.eventHelp_table = this.eventHelp_table.filter((val) => val !== this.eventHelpTable);
                this.displayConfirmation = false;
            } else if (this.deleteAt == 'operating-table') {
                this.eventOperating_table = this.eventOperating_table.filter((val) => val !== this.eventOperatingTable);
                this.displayConfirmation = false;
            } else if (this.deleteAt == 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            } else {
                await this.axios.post(`${this.$url_service}/disaster?user=${this.getUsername()}`, {
                    body: {
                        topic: 'delete-disaster',
                        id: this.temp
                    }
                });
                // this.initialData()
                this.searchDisasterInfo();
                this.displayConfirmation = false;
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลสาธารณภัย",
                //   life: 3000,
                // });
                this.$fire({
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลสาธารณภัย',
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async saveData() {
            //Check null value
            if (
                this.id_disaster_name == '' ||
                this.id_disasterTypeSelect == null ||
                this.id_selectedProvince == null ||
                this.id_selectedAmphur == null ||
                this.id_selectedTambon == null
            ) {
                if (this.id_disaster_name == '') {
                    this.error_id_disaster_name = true;
                }
                if (this.id_disasterTypeSelect == null) {
                    this.error_id_disasterTypeSelect = true;
                }
                if (this.id_selectedProvince == null) {
                    this.error_id_selectedProvince = true;
                }
                if (this.id_selectedAmphur == null) {
                    this.error_id_selectedAmphur = true;
                }
                if (this.id_selectedTambon == null) {
                    this.error_id_selectedTambon = true;
                }
            } else {
                if (this.selectedData == '') {
                    var date_add;
                    if (this.id_disasterDate != '') {
                        const date = new Date(this.id_disasterDate);
                        const ye = new Intl.DateTimeFormat('en', {
                            year: 'numeric'
                        }).format(date);
                        const mo = new Intl.DateTimeFormat('en', {
                            month: '2-digit'
                        }).format(date);
                        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
                        const h = date.getHours();
                        const m = date.getMinutes();
                        const s = date.getSeconds();
                        date_add = `${ye}-${mo}-${da} ${h}:${m}:${s}`;
                    } else {
                        date_add = null;
                    }

                    const userId = this.getUsername();

                    await this.axios.post(`${this.$url_service}/disaster?user=${userId}`, {
                        body: {
                            topic: 'add-disaster',
                            name: this.id_disaster_name,
                            date: date_add,
                            disaster_type: this.id_disasterTypeSelect.system_id,
                            disaster_detail: this.id_disaster_detail,
                            disaster_locate: this.id_disasterLocation,
                            status: this.id_disasterStatusSelect.id,
                            location_id: this.id_selectedTambon.tambon_id,
                            call_name: this.id_call_name,
                            call_phone: this.id_call_phone,
                            cause_id: this.id_disaster_reason,
                            cause_detail: this.id_disaster_reason_detail,
                            level_id: this.id_disaster_level.id,
                            level_detail: this.id_disaster_level_deail,
                            effect_area: this.id_disaster_area,
                            lat: this.id_lat,
                            lon: this.id_lon,
                            movement: this.id_disaster_movement,
                            detail: this.id_remark,
                            daily_event_call_name: this.id_disaster_daily_call,
                            daily_event_group1: this.id_disaster_daily_group1,
                            daily_event_group2: this.id_disaster_daily_group2,
                            daily_event_group3: this.id_disaster_daily_group3,
                            file_table: this.eventFile_table,
                            help_table: this.eventHelp_table,
                            operator_table: this.eventOperating_table,
                            userOrg: this.getUserOrganize()
                        }
                    });
                    // this.initialData()
                    this.searchDisasterInfo();
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    // this.$toast.add({
                    //   severity: "success",
                    //   summary: "เพิ่มข้อมูลสำเร็จ",
                    //   detail: "ข้อมูลสาธารณภัย",
                    //   life: 3000,
                    // });
                    this.$fire({
                        title: 'เพิ่มข้อมูลสำเร็จ',
                        text: 'ข้อมูลสาธารณภัย',
                        type: 'success',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });

                    this.disasterInfoModal = false;
                } else {
                    var date_edit;
                    if (this.id_disasterDate != this.selectedData.event_date_alias) {
                        if (this.id_disasterDate != '' && this.id_disasterDate != null) {
                            const date = new Date(this.id_disasterDate);
                            const ye = new Intl.DateTimeFormat('en', {
                                year: 'numeric'
                            }).format(date);
                            const mo = new Intl.DateTimeFormat('en', {
                                month: '2-digit'
                            }).format(date);
                            const da = new Intl.DateTimeFormat('en', {
                                day: '2-digit'
                            }).format(date);
                            const h = date.getHours();
                            const m = date.getMinutes();
                            const s = date.getSeconds();
                            date_edit = `${ye}-${mo}-${da} ${h}:${m}:${s}`;
                        } else {
                            date_edit = null;
                        }
                    } else {
                        if (this.selectedData.event_date != null) {
                            const date = new Date(this.selectedData.event_date);
                            const ye = new Intl.DateTimeFormat('en', {
                                year: 'numeric'
                            }).format(date);
                            const mo = new Intl.DateTimeFormat('en', {
                                month: '2-digit'
                            }).format(date);
                            const da = new Intl.DateTimeFormat('en', {
                                day: '2-digit'
                            }).format(date);
                            const h = date.getHours();
                            const m = date.getMinutes();
                            const s = date.getSeconds();
                            date_edit = `${ye}-${mo}-${da} ${h}:${m}:${s}`;
                        } else {
                            date_edit = null;
                        }
                    }
                    await this.axios.post(`${this.$url_service}/disaster?user=${this.getUsername()}`, {
                        body: {
                            topic: 'edit-disaster',
                            id: this.temp,
                            name: this.id_disaster_name,
                            date: date_edit,
                            disaster_type: this.id_disasterTypeSelect.system_id,
                            disaster_detail: this.id_disaster_detail,
                            disaster_locate: this.id_disasterLocation,
                            status: this.id_disasterStatusSelect.id,
                            location_id: this.id_selectedTambon.tambon_id,
                            call_name: this.id_call_name,
                            call_phone: this.id_call_phone,
                            cause_id: this.id_disaster_reason,
                            cause_detail: this.id_disaster_reason_detail,
                            level_id: this.id_disaster_level.id,
                            level_detail: this.id_disaster_level_deail,
                            effect_area: this.id_disaster_area,
                            lat: this.id_lat,
                            lon: this.id_lon,
                            movement: this.id_disaster_movement,
                            detail: this.selectedData.event_detail.includes('{') ? this.selectedData.event_detail : this.id_remark,
                            daily_event_call_name: this.id_disaster_daily_call,
                            daily_event_group1: this.id_disaster_daily_group1,
                            daily_event_group2: this.id_disaster_daily_group2,
                            daily_event_group3: this.id_disaster_daily_group3,
                            file_table: this.eventFile_table,
                            help_table: this.eventHelp_table,
                            operator_table: this.eventOperating_table
                        }
                    });
                    // this.initialData()
                    this.searchDisasterInfo();
                    // this.$toast.add({
                    //   severity: "success",
                    //   summary: "แก้ไขข้อมูลสำเร็จ",
                    //   detail: "ข้อมูลสาธารณภัย",
                    //   life: 3000,
                    // });
                    this.$fire({
                        title: 'เพิ่มข้อมูลสำเร็จ',
                        text: 'ข้อมูลสาธารณภัย',
                        type: 'success',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    this.disasterInfoModal = false;
                }
            }
        },

        async editData(data) {
            // console.log(data);
            this.header = this.$i18n.t('id_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/disaster`, {
                    body: {
                        topic: 'showone-disaster',
                        id: data
                    }
                })
                .then((response) => {
                    // console.log('response.data.data=',response.data.data),
                    (this.selectedData = response.data.data),
                        (this.id_disaster_name = response.data.data.event_name),
                        (this.id_disaster_detail = `${response.data.data.disaster_detail == 'null' ? '-' : response.data.data.disaster_detail}`),
                        (this.id_disasterDate = response.data.data.event_date_alias),
                        (this.id_disasterTypeSelect = {
                            system_id: response.data.data.disaster_id,
                            system_name: response.data.data.disaster_name
                        }),
                        (this.id_disasterLocation = response.data.data.location),
                        (this.id_disasterStatusSelect = {
                            id: response.data.data.event_status,
                            name: this.$i18n.t(`${response.data.data.event_status}`)
                        }),
                        (this.id_selectedProvince = {
                            province_id: response.data.data.province_id,
                            province_name: response.data.data.province_name
                        }),
                        (this.id_selectedAmphur = {
                            amphur_id: response.data.data.amphur_id,
                            amphur_name: response.data.data.amphur_name
                        }),
                        (this.id_selectedTambon = {
                            tambon_id: response.data.data.tambon_id,
                            tambon_name: response.data.data.tambon_name
                        }),
                        (this.id_call_name = response.data.data.report_name),
                        (this.id_call_phone = response.data.data.report_phone),
                        (this.id_disaster_reason_detail = response.data.data.event_cause_detail),
                        (this.id_disaster_level = {
                            id: response.data.data.event_level,
                            name: response.data.data.event_level
                        }),
                        (this.id_disaster_level_deail = response.data.data.event_level_detail),
                        (this.id_disaster_area = response.data.data.effect_area),
                        (this.id_lat = response.data.data.event_lat),
                        (this.id_lon = response.data.data.event_lon),
                        // (this.$emit('selectLocationDisaster_lat',response.data.data.event_lat)),
                        // (this.$emit('selectLocationDisaster_lon',response.data.data.event_lon)),
                        (this.id_disaster_movement = response.data.data.event_movement),
                        (this.id_remark = response.data.data.event_detail),
                        (this.id_disaster_daily_call = response.data.data.daily_event_name),
                        (this.eventFile_table = JSON.parse(response.data.data.event_file_table)),
                        (this.eventHelp_table = JSON.parse(response.data.data.event_help_table)),
                        (this.eventOperating_table = JSON.parse(response.data.data.event_operator_table));

                    this.date_create_form = response.data.data.date_create_ddmmyy == null ? '-' : response.data.data.date_create_ddmmyy;
                    this.date_update_form = response.data.data.date_update_ddmmyy == null ? '-' : response.data.data.date_update_ddmmyy;

                    // Doe เพิ่มหมุด map V.2 7/9
                    if (this.id_lat !== '' && this.id_lat !== null && this.id_lon !== '' && this.id_lon !== null) {
                        this.inputMap_latlon();
                    } else {
                        this.inputMap_PAT_latlon();
                    }
                    // Doe เพิ่มหมุด map V.2 7/9  จบ
                });
            this.disasterInfoModal = true;
        },

        editEventHelpData(data) {
            // console.log(data);
            this.headerEventHelp = this.$i18n.t('id_help_modal_title_edit');
            this.id_help_receive = new Date(data.receive);
            this.id_help_work = new Date(data.work);
            this.id_help_socialWorker = data.socialWork;
        },

        editEventOperatingData(data) {
            // console.log(data);
            this.temp_organize_id = data.operating_id;
            this.headerEventOperating = this.$i18n.t('id_operating_modal_title_edit');
            this.id_operating_modal_id = { organize_id: data.operating_id };
            this.id_operating_modal_type = { system_name: data.operating_type };
            this.id_operating_modal_name = { organize_name: data.operating_name };
            if (data.receive != '-') {
                this.id_operating_modal_receive = new Date(data.receive);
            } else {
                this.id_operating_modal_receive = null;
            }
            if (data.work != '-') {
                this.id_operating_modal_work = new Date(data.work);
            } else {
                this.id_operating_modal_work = null;
            }
            if (data.arrive != '-') {
                this.id_operating_modal_arrive = new Date(data.arrive);
            } else {
                this.id_operating_modal_arrive = null;
            }
            if (data.leave != '-') {
                this.id_operating_modal_leave = new Date(data.leave);
            } else {
                this.id_operating_modal_leave = null;
            }
            if (data.destination != '-') {
                this.id_operating_modal_destination = new Date(data.destination);
            } else {
                this.id_operating_modal_destination = null;
            }
            this.id_operating_modal_checkMainOrganize = data.organize;
            this.id_operating_modal_man = data.man;
            this.id_operating_modal_vehicle = data.vehicle;
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('id_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.disasterInfoModal = false;
                this.selectedData = '';
                this.setDefault();
                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            // console.log("00")
            this.id_disaster_name = '';
            this.id_disaster_detail = '';
            this.id_disasterDate = '';
            this.id_disasterTypeSelect = null;
            this.id_disasterDetailSelect = null;
            this.id_disasterStatusSelect = {
                id: 'onworking',
                name: this.$i18n.t('onworking')
            };

            // console.log("this.id_selectedProvince",this.id_selectedProvince)
            this.id_disasterLocation = '';
            this.id_selectedProvince = null;
            this.id_isDisabledAmphur = 1;
            this.id_selectedAmphur = null;
            this.id_isDisabledTambon = 1;
            this.id_selectedTambon = null;
            this.id_disaster_area = '';
            this.id_call_name = '';
            this.id_call_phone = '';
            this.id_disaster_reason = null;
            this.id_disaster_reason_detail = '';
            this.id_disaster_level = { id: '1', name: '1' };
            this.id_disaster_level_deail = '';
            this.id_lat = '';
            this.id_lon = '';
            this.id_disaster_movement = '';
            this.id_remark = '';
            this.id_disaster_daily_call = '';

            this.id_disaster_daily_group1 = null;
            this.id_disaster_daily_group2 = null;
            this.id_disaster_daily_group3 = null;

            this.eventFile_table = [];
            this.eventHelp_table = [];
            this.eventOperating_table = [];

            // this.id_selectedProvince = null;
            // this.id_selectedAmphur = null;
            // this.id_selectedTambon = null;

            this.error_id_disaster_name = false;
            this.error_id_disasterTypeSelect = false;
            this.error_id_selectedProvince = false;
            this.error_id_selectedAmphur = false;
            this.error_id_selectedTambon = false;
            this.error_id_operating_modal_name = false;

            this.provinceEKanit = '';
            this.amphurEKanit = '';
            this.tambonEKanit = '';

            this.date_create_form = '';
            this.date_update_form = '';
        },

        clearSubFileData() {
            this.dropdownClearFilerValue += 1;

            this.id_event_file_name = '';
            this.id_event_file_detail = '';
            this.id_fileTypeSelect = null;
            this.url = null;
            document.getElementById('id_uploadFile').value = '';
            this.deleteAt = '';
            this.editAt = '';
            this.error_id_event_file_name = false;
            this.error_id_fileTypeSelect = false;
            this.error_url = false;
        },

        clearSubHelpData() {
            this.dropdownClearFilerValue += 1;

            this.headerEventHelp = this.$i18n.t('id_help_modal_title_add');
            this.id_help_receive = null;
            this.id_help_work = null;
            this.id_help_socialWorker = '';
            this.deleteAt = '';
            this.editAt = '';
            this.error_id_help_receive = false;
            this.error_id_help_work = false;
        },

        clearSubOperatingData() {
            this.dropdownClearFilerValue += 1;

            this.headerEventOperating = this.$i18n.t('id_operating_modal_title_add');
            this.id_operating_modal_id = '';
            this.id_operating_modal_type = null;
            this.id_operating_modal_name = null;
            this.id_operating_modal_receive = null;
            this.id_operating_modal_work = null;
            this.id_operating_modal_arrive = null;
            this.id_operating_modal_leave = null;
            this.id_operating_modal_destination = null;
            this.id_operating_modal_man = 0;
            this.id_operating_modal_vehicle = 0;
            this.id_operating_modal_checkMainOrganize = [];
            this.temp_organize_id = '';
            this.deleteAt = '';
            this.editAt = '';
            this.error_id_operating_modal_type = false;
            this.error_id_operating_modal_name = false;
        },

        async clearSearchField() {
            this.dropdownClearFilerValue += 1;
            this.organize_table = [];

            this.event_name = '';
            this.disaster_detail = '';
            this.startDate = null;
            this.toDate = null;
            this.disasterTypeSelect = null;
            this.disasterStatusSelect = null;
            this.selectedProvince = null;
            this.disaster_location = '';
            this.selectedOrganize = {};
            this.filters = {};

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            // await this.axios
            //   .post(`${this.$url_service}/disaster`,
            //   { body: {
            //     topic: "get-table" ,
            //     // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
            //   } })
            //   .then((response) => (this.disasterInfo_table = response.data.data));
        },
        // Doe :   เพิ่ม มุดmap 4/4
        sendM(id_lat, id_lon) {
            let lat = id_lat;
            let lon = id_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province) {
            if (tambon) {
                this.PAT = tambon;
            } else if (amphur) {
                this.PAT = amphur;
            } else if (province) {
                this.PAT = province;
            } else {
                this.PAT = {};
            }
        },

        //  Doe เพิ่มหมุด map V.2 8/9  -->
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.id_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.id_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.id_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }
                // if(land_ID == "00"){
                //   this.error_latlon_land = true
                // }else{
                //   this.error_latlon_land = false
                // }

                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.id_selectedProvince = null;
                this.id_selectedAmphur = null;
                this.id_selectedTambon = null;
            }

            // console.log("receiveM_PAT-------------------")
            // console.log("country_ID",country_ID)
            // console.log("land_ID",land_ID)
            // console.log("this.id_selectedProvince",this.id_selectedProvince)
            // console.log("this.id_selectedAmphur",this.id_selectedAmphur)
            // console.log("this.id_selectedTambon",this.id_selectedTambon)
        },
        //  Doe เพิ่มหมุด map V.2 8/9  จบ-->
        // Doe :   เพิ่ม มุดmap 4/4 จบ
        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp);
                }
            });
        }
    }
};
</script>

<style scoped>
/*   Doe เพิ่มหมุด map V.2 9/9  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 9/9  จบ--> */
.table_row {
    text-align: center;
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    height: 150px;
    width: 180px;
    border: solid 1px #cccccc;
}
@media screen and (min-width: 538px) and (max-width: 1200px) {
    #Search {
        width: 21rem;
    }
}
@media screen and (min-width: 538px) {
    #Create {
        width: 146px;
    }
}

@media screen and (max-width: 430px) {
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

.p-multiselect {
    min-width: 15rem;
}

:deep(.p-calendar) {
    .p-datepicker {
        top: 32px !important;
    }
}

.p-datepicker2 {
    // width: auto;
    // max-width: 11rem;
    overflow-y: 'auto';
}
// .p-calendar .p-datepicker {
//   top:-132px;
// }
.multiselect-custom {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
    //   .swal2-container {
    //   z-index:9999;
    // }
}
</style>
